var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "confirm_area" }, [
      _c("div", { staticClass: "input_confirm6" }, [
        _c("ul", [
          _c("li", [
            _c("span", [_vm._v("注文番号")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.orderData.planEc.ecOrderNo))])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [_vm._v("ご注文日")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.getDate(_vm.orderData.planData.planOrderDate)))
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [_vm._v("ご請求額")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.formatPrice(_vm.orderData.planEc.ecSnapPrice)))
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [_vm._v("施主名")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.orderData.planData.planDeliveryName))
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [_vm._v("納品先")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.deliAddress))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "action_area" }, [
          _c(
            "div",
            {
              staticClass: "main_btn sel_main_btn",
              on: {
                click: function($event) {
                  _vm.detail()
                }
              }
            },
            [_c("a", [_vm._v("詳細を見る")])]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a68c946", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a68c946","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/components/order/DcOrderHistory.vue
// module id = null
// module chunks = 